import { IMensagem } from "@/interfaces/IMensagem";
import { TipoMensagem } from "@/consts/consts";
import { store } from "@/store/index";

type Mensagem = {
    InserirMensagem: (pTitulo: string, pMensagem: string, pTipo: TipoMensagem) => void,
    Selecionar: () => void,
    ExcluirMensagem: (pId: string) => void
};

export default (): Mensagem => {
    const InserirMensagem = (pTitulo: string, pMensagem: string, pTipo: TipoMensagem) => {
        const msg = {} as IMensagem;
        msg.Id = new Date().getTime().toString();
        msg.Titulo = pTitulo;
        msg.Tipo = pTipo;
        msg.Mensagem = pMensagem;

        store.dispatch("changeMensagens", msg);
        return msg.Id;
    };
    const Selecionar = () => {
        // const msg =  {} as IMensagem;

        // return store.dispatch("changeMensagens", msg);       
    };

    const ExcluirMensagem = (pId: string) => {
        store.dispatch("deleteMensagens", pId);
    };

    return {
        InserirMensagem,
        Selecionar,
        ExcluirMensagem
    };
};